import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";
import errorSign from "../../assets/images/errorSign.svg";
import "./mustyle.scss";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 340,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  p: 4,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

const DeleteModal = ({ openDeleteModal, setOpenDeleteModal, handleDelete }) => {
  useEffect(() => {
    if (openDeleteModal) {
      const timeoutId = setTimeout(() => {
        document.getElementById("cancel-button-id")?.focus();
      }, 100);
      return () => clearTimeout(timeoutId);
    }
  }, [openDeleteModal]);

  const confirmDelete = () => {
    handleDelete();
    setOpenDeleteModal(false);
  };

  return (
    <div className="delte_modal_wrapper">
      <Modal
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        className="delte_modal"
        aria-labelledby="Delete-modal-title-building"
        aria-modal="true"
      >
        <div role="none">
          <Box
            sx={style}
            role="dialog"
            aria-labelledby="Delete-modal-title-building"
          >
            <div className="Modal_header">
              <h1 id="Delete-modal-title-building">
                <img
                  src={errorSign}
                  alt=""
                  aria-hidden="true"
                  className="manageUserDeleteImg"
                />{" "}
                Delete
              </h1>
            </div>

            <div className="Modal_middle">
              <p id="delete-paragraph">
                Are you sure you want to delete this building?
              </p>
            </div>

            <div className="Modal_footer">
              <Box sx={{ display: "flex", gap: 2 }}>
                <Button
                  id="cancel-button-id"
                  variant="outlined"
                  className="cancelBtn"
                  onClick={() => setOpenDeleteModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  className="saveBtn"
                  aria-label="Delete"
                  onClick={confirmDelete}
                >
                  Delete
                </Button>
              </Box>
            </div>
          </Box>
        </div>
      </Modal>
    </div>
  );
};

DeleteModal.propTypes = {
  openDeleteModal: PropTypes.bool.isRequired,
  setOpenDeleteModal: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default DeleteModal;
